import { Popover, Typography } from '@mui/material';
import { Box } from '@mui/system';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useState } from 'react';
import formatString from '@utils/formatString';

function ThemeSelection({
  themes,
  selectedTheme,
  selectedCategory,
  setSelectedTheme,
  setSelectedCategory,
}) {
  const [openPopover, setOpenPopover] = useState(null);
  const [openPopoverTwo, setOpenPopoverTwo] = useState(null);

  const handleOpenPopover = (e) => {
    setOpenPopover(e.currentTarget);
  };
  const handleClose = () => {
    setOpenPopover(null);
  };
  const handleOpenPopoverTwo = (e) => {
    setOpenPopoverTwo(e.currentTarget);
  };
  const handleCloseTwo = () => {
    setOpenPopoverTwo(null);
  };
  const open = Boolean(openPopover);
  const pop1Id = open ? 'simple-popover' : undefined;
  const openTwo = Boolean(openPopoverTwo);
  const pop2Id = openTwo ? 'simple-popover' : undefined;
  return (
    <>
      <Box display={'flex'} mb={0.8}>
        <Box mt={2}>
          <Typography
            variant="subtitle2"
            display={'flex'}
            alignItems={'center'}
            color={'#6B6B6B'}
            aria-describedby="code-filter"
            onClick={(e) => handleOpenPopover(e)}
            sx={{
              cursor: 'pointer',
              bgcolor: '#d9e8fe',
              px: 1,
              py: 0.2,
              borderRadius: '4px',
            }}
          >
            {selectedTheme == 'all' ? 'All Themes' : selectedTheme?.name}
            <ArrowDropDownIcon />
          </Typography>
        </Box>
        {selectedTheme !== 'all' && (
          <Box mt={2} display={'flex'} alignItems={'center'} ml={1}>
            <Typography
              variant="subtitle2"
              display={'flex'}
              alignItems={'center'}
              color={'#6B6B6B'}
              aria-describedby="code-filter-two"
              sx={{
                cursor: 'pointer',
                bgcolor: '#d9e8fe',
                px: 1,
                py: 0.2,
                borderRadius: '4px',
              }}
              onClick={(e) => handleOpenPopoverTwo(e)}
            >
              <KeyboardArrowRightIcon />
              {selectedCategory == null ? 'All Category' : formatString(selectedCategory || '')}
              <ArrowDropDownIcon />
            </Typography>
          </Box>
        )}
      </Box>
      <Popover
        id={pop1Id}
        open={open}
        anchorEl={openPopover}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box py={2}>
          <Typography
            sx={{
              px: 2,
              py: 1,
              cursor: 'pointer',
              backgroundColor: `${selectedTheme == null && 'rgba(0, 0, 0, 0.06)'}`,
              //   borderRadius: 1,
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.1)',
              },
            }}
            onClick={() => {
              setSelectedTheme('all');
              handleClose();
            }}
          >
            All Themes
          </Typography>
          {themes.map((item) => (
            <Typography
              key={item.name}
              sx={{
                px: 2,
                py: 1,
                cursor: 'pointer',
                backgroundColor: `${selectedTheme?.name == item.name && 'rgba(0, 0, 0, 0.06)'}`,
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.1)',
                },
              }}
              onClick={() => {
                handleClose();
                setSelectedTheme(item);
                setSelectedCategory(null);
              }}
            >
              {item.name}
            </Typography>
          ))}
        </Box>
      </Popover>
      <Popover
        id={pop2Id}
        open={openTwo}
        anchorEl={openPopoverTwo}
        onClose={handleCloseTwo}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box py={2}>
          <Typography
            sx={{
              px: 2,
              py: 1,
              cursor: 'pointer',
              backgroundColor: `${selectedTheme == null && 'rgba(0, 0, 0, 0.06)'}`,
              //   borderRadius: 1,
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.1)',
              },
            }}
            onClick={() => {
              setSelectedCategory(null);
              handleClose();
            }}
          >
            All Category
          </Typography>
          {selectedTheme?.categories_included?.map((name) => (
            <Typography
              key={name}
              sx={{
                px: 2,
                py: 1,
                cursor: 'pointer',
                backgroundColor: `${name == selectedCategory && 'rgba(0, 0, 0, 0.06)'}`,
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.1)',
                },
              }}
              onClick={() => {
                handleCloseTwo();
                setSelectedCategory(name);
              }}
            >
              {formatString(name || '')}
            </Typography>
          ))}
        </Box>
      </Popover>
    </>
  );
}

export default ThemeSelection;
